import { RefObject } from 'react';
import type { Swiper } from 'swiper';

interface AriaLiveAnnouncementOptions {
  ariaLiveRef: RefObject<HTMLDivElement>;
  swiper: Swiper;
  slidesPerView?: number;
  activeIndex?: number;
  getAriaLiveLabel?: (startSlide: number, endSlide: number, totalSlides: number) => string;
}

// Updates the aria-live region to announce current slide position
export const updateAriaLiveAnnouncement = ({
  ariaLiveRef,
  swiper,
  slidesPerView,
  activeIndex,
  getAriaLiveLabel,
}: AriaLiveAnnouncementOptions) => {
  if (!ariaLiveRef.current) {
    return;
  }

  const spv = slidesPerView ?? (swiper?.params.slidesPerView ? Math.floor(swiper.params.slidesPerView as number) : 1);
  const loopedSlides = swiper?.loopedSlides ?? 0;
  const totalSlides = swiper ? swiper.slides.length - loopedSlides * 2 : 0;

  if (totalSlides === 0) {
    return;
  }

  const start = Math.max(
    Math.min(activeIndex !== undefined ? activeIndex : (swiper?.realIndex ?? 0) + 1, totalSlides),
    1,
  );

  const end = Math.max(Math.min(start + spv - 1, totalSlides), start);

  // Update aria-live region with custom label or default
  if (getAriaLiveLabel) {
    ariaLiveRef.current.textContent = getAriaLiveLabel(start, end, totalSlides);
  } else {
    // Fallback to simple format
    ariaLiveRef.current.textContent = start === end ? `${start} / ${totalSlides}` : `${start}-${end} / ${totalSlides}`;
  }
};
